import { formatPastDaysBeforeDate } from '@doda/common/src/logics/JobContent/createFormatDate';
import { Text } from '@doda/io-react/common';

/**
 * ランキング注釈のProps
 * @property updatedDate 更新日
 */
interface RankingNoteProps {
  updatedDate: string;
}

/**
 * ランキング注釈
 */
export const RankingNote = ({ updatedDate }: RankingNoteProps) => {
  // ランキング更新日から集計期間を算出する
  const aggregateFrom = formatPastDaysBeforeDate(updatedDate, 7);
  const aggregateTo = formatPastDaysBeforeDate(updatedDate, 1);

  return (
    <Text color="gray" size="12" weight="normal">
      ※求人応募数の多い順にランキングしています（非公開求人は除く）。
      <br />
      {`※集計対象期間：${aggregateFrom}～${aggregateTo}`}
      <br />
      ※事情により掲載終了予定日よりも前に求人募集が終了していることもございます。その場合は当サイトから応募はできませんので、あらかじめご了承ください。
    </Text>
  );
};
